import React from 'react';

export const RefreshEnabledFeaturesContext = React.createContext<() => void>(() => {});
